<template>
  <div id="modal-navigation-container" class="flex-row flex-md-column">
      <a :class="['dot mx-2 mx-md-0', currentIndex === index && 'active']"
         v-for="(item, index) in items"
         @click.prevent="$emit('change', index)"
         href="#"
      />
  </div>
</template>

<script>
  import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'navbar',
    components: { FontAwesomeIcon, FontAwesomeLayers },
    props: {
      total: {
        type: Number,
        default: 0
      },
      currentIndex: {
        type: Number,
        default: 0
      }
    },
    computed: {
      items () {
        return [...Array(this.total).keys()]
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/colors.scss';

  #modal-navigation-container {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: 100%;
    z-index: 9999;

    @media (min-width: 767px) {
      align-items: center;

    }
  }

  .dot {
    height: 15px;
    width: 15px;
    background-color: #00839E;
    border-radius: 50%;
    display: inline-block;
    margin-left: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
    cursor: pointer;

    &:hover {
      background-color: #F18800;
      opacity: 0.85;
    }

    &.active {
      height: 25px;
      width: 25px;
      background-color: #F18800;
    }
  }

  .aside {
    text-align: center;
    padding: 0;
    margin: 0;
    list-style-type: none;
    @media (max-width: 594px) {
    }
  }

  @keyframes collapsing-sidebar {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }

    100% {
      opacity: 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/NavigationModal.vue